import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Store, { TWO_FACTOR_ENROLLMENT_TOKEN_KEY, translateError } from '../store/Store'
import { Page } from '../components/ui/Page'
import { Body } from '../components/layout/Body'
import { Loading } from '../components/ui/Loading'

// public route #/2fa/enroll?token=... (one-time link from the 2FA e-mail)
// - stores the token in the sessionStorage
// - logged in: redeem the token (POST 2fa/enroll) and continue on the 2FA page
// - not logged in: go to the login, the 2FA page redeems the stored token after the login
export default function TwoFactorEnrollPage() {
	const [searchParams] = useSearchParams()
	const navigate = useNavigate()
	const isLoaded = Store.use('isLoaded')
	const isLoggedIn = Store.use('isLoggedIn')
	const [error, setError] = useState<string | null>(null)
	const done = useRef(false)

	const token = searchParams.get('token')

	useEffect(() => {
		if (done.current || !isLoaded) return

		if (!token) {
			done.current = true
			setError(translateError('2FA_ENROLLMENT_TOKEN_INVALID'))
			return
		}

		sessionStorage.setItem(TWO_FACTOR_ENROLLMENT_TOKEN_KEY, token)

		// a user session from sessionStorage is still being restored -> wait for isLoggedIn
		if (!isLoggedIn && sessionStorage.getItem('user')) return

		done.current = true

		if (!isLoggedIn) {
			Store.setPopupMessage(
				'info',
				'2-Faktor-Authentifizierung',
				'Bitte melden Sie sich an, um die Einrichtung der 2-Faktor-Authentifizierung abzuschließen.',
				8000
			)
			navigate('/login', { replace: true })
			return
		}

		; (async () => {
			const result = await Store.enrollTwoFactor(token)
			if (result.ok) {
				navigate('/2fa', { replace: true })
			} else {
				setError(result.errorMessage ?? translateError('2FA_ENROLLMENT_TOKEN_INVALID'))
			}
		})()
	}, [isLoaded, isLoggedIn, token, navigate])

	return (
		<Page id="twofactor-enroll" className="content-center">
			<Body id="twofactor-enroll-body">
				<h1 className="home-page-header">2-Faktor-Authentifizierung</h1>
				{error ? (
					<div className="mt-6 max-w-xl bg-red-100 text-red-700 p-3 rounded" data-pw="twofactor-enroll-error">
						{error}
					</div>
				) : (
					<div className="mt-6">
						<Loading spinner />
					</div>
				)}
			</Body>
		</Page>
	)
}
